module.exports = __webpack_public_path__ + "static/media/startup_banner_bg.f99f361b.png";